import React from 'react';
import ServicePageArea from '../../../../components/ServiceArea/ServicePageArea';

const ServicesArea = () => {
   return ( 
      <> 
         <section className="tp-service-area-three pt-120 pb-90">
            <div className="container">
               <div className="row">
                  <div className="col-12">
                     <div className="section-title-wrapper text-center mb-55 wow fadeInUp" data-wow-delay=".3s">
                        <h5 className="tp-section-subtitle section__sm__title common-yellow-shape mb-20 heading-color-black">Nos meilleurs services</h5>
                        <h2 className="tp-section-title heading-color-black">Un nettoyage de qualité pour votre plus grand <br/>bonheur</h2>
                     </div>
                  </div>
               </div>
               <div className="row">
               
               <ServicePageArea service_image_num="3" ser_icon_img="house-cleaning" 
               ser_title="Nettoyage de la maison" ser_subtitle="Luminosité garantie – Intérieur & Extérieur – De la maison à l’immeuble. Décrassage minutieux, Lavage sans traces, Finitions impeccables"></ServicePageArea>
 
               <ServicePageArea service_image_num="2" ser_icon_img="pot" 
               ser_title="Nettoyage de Cuisine" ser_subtitle="Transformez votre cuisine en un espace étincelant et hygiénique ! Notre service spécialisé élimine graisses tenaces, bactéries et désordre"></ServicePageArea>
 
               <ServicePageArea service_image_num="4" ser_icon_img="desk" 
               ser_title="Nettoyage de bureaux" ser_subtitle="Service quotidien/sur mesure – Zéro perturbation – Écoresponsable. Nettoyage quotidien, Grands espaces (open spaces, salles de réunion > 50m²), Zones sensibles"></ServicePageArea>

               <ServicePageArea service_image_num="3" ser_icon_img="vacuum-cleaner" 
               ser_title="Nettoyage de chambre" ser_subtitle="Élimination des taches, allergènes et odeurs – Résultat professionnel garanti. Nettoyage à la vapeur (extraction)"></ServicePageArea>

               </div>
            </div>
         </section>
      </>
   );
};

export default ServicesArea;